import raIt from './it/ra'
import raEn from './en/ra'

import translationIt from './it/translation'
import translationEn from './en/translation'

const translation = {
  it: {
    ...raIt,
    translation: translationIt,
  },
  en: {
    ...raEn,
    translation: translationEn,
  },
}

export default translation
